import "./AppHeaderComponent.scss";
import {ImageConfig} from "@/constants";
import HeaderUserIconComponent from "@/components/common-components/header-user-icon/HeaderUserIconComponent.tsx";
import CreditsPopoverComponent from "@/components/common-components/credits-popover/CreditsPopoverComponent.tsx";
import { useSidebar } from "@/components/ui/sidebar.tsx";
import { useIsMobile } from "@/hooks/use-mobile";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";


const AppHeaderComponent = () => {
    const { toggleSidebar } = useSidebar();
    const isMobile = useIsMobile();

    return (
        <div className="app-header fixed top-0 left-0 right-0 bg-background z-50 border-b">
            <header className="flex flex-col justify-between h-full">
                <div className="flex justify-between items-center px-4 h-full">
                    <div className={'flex ts-align-items-center'}>
                        {isMobile ? (
                            <ImageConfig.LogoSmallIcon className="h-8 w-8" />
                        ) : (
                            <ImageConfig.MediumLogo/>
                        )}
                    </div>
                    <div className={'header-right-wrapper flex items-center gap-2'}>
                        {/*<Button*/}
                        {/*    variant={'headerOutline'}*/}
                        {/*    size={"header"}*/}
                        {/*    prefixIcon={<UserRoundCheckIcon className={"small"} size={14}/> as ReactNode}*/}
                        {/*    onClick={() => {*/}
                        {/*        window.location.href = `mailto:info@superengineer.ai?subject=Enterprise Plan Inquiry&body=Hi, I'm interested in learning more about the Enterprise Plan.`;*/}
                        {/*    }}*/}
                        {/*    mixpanelEvent={{*/}
                        {/*        name: "get_expert_support_button_clicked"*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    Get Expert Support*/}
                        {/*</Button>*/}
                        {isMobile && (
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={toggleSidebar}
                                className="h-8 w-8 p-0 hover:bg-accent"
                            >
                                <Menu className="h-4 w-4" />
                            </Button>
                        )}
                        <div className={'vertical-separator'}/>
                        <CreditsPopoverComponent />
                        <div className={'vertical-separator'}/>
                        <HeaderUserIconComponent/>
                    </div>
                </div>
            </header>
        </div>
    );

};

export default AppHeaderComponent;
